import { esusApi } from "@/services/api";
import { DentalAttendanceProcedure } from "@/@types/esus/DentalAttendanceProcedure";

export type DetailedCitizenProceduresIndicatorB6Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenProceduresIndicatorB6 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	dentalAttendanceProcedures?: DentalAttendanceProcedure[];
}

export async function getDetailedCitizenProcedureIndicatorB6({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenProceduresIndicatorB6Params) {
	const response = await esusApi.get<DetailedCitizenProceduresIndicatorB6>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b6/detailed-citizen-procedures`,
		params
	);
	return response.data ?? new DetailedCitizenProceduresIndicatorB6();
}
